import { FC } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { REACTIONS_TYPES } from "@shared/constants";
import styles from "./ReactionsLayout.module.scss";

const TabList = [
  { value: "Лайки", link: "/reactions/likes", type: REACTIONS_TYPES.Likes },
  {
    value: "Окружение",
    link: "/reactions/matches",
    type: REACTIONS_TYPES.Matches,
  },
  { value: "Рейтинг", link: "/reactions/userRating", type: "userRating" },
];

export const ReactionsLayout: FC = () => {
  const location = useLocation();

  const getActiveType = () => {
    if (location.pathname.includes("likes")) return REACTIONS_TYPES.Likes;
    if (location.pathname.includes("matches")) return REACTIONS_TYPES.Matches;
    if (location.pathname.includes("userRating")) return "userRating";
    return "";
  };

  const activeType = getActiveType();

  return (
    <section className={styles.wrapper}>
      <div className={styles.linksContainer}>
        {TabList.map((targetLink, idx) => {
          const isActive = targetLink.type === activeType;
          return (
            <Link
              key={idx}
              className={`${styles.linksItem} ${isActive ? styles.active : ""}`}
              to={targetLink.link}
            >
              {targetLink.value}
            </Link>
          );
        })}
      </div>
      <Outlet />
    </section>
  );
};
